import { Box, Grid, Paper, Typography, Alert, Button, IconButton, Toolbar, Stack } from "@mui/material"
import { useEffect, useState } from "react"
import { useParams } from "react-router"
import apis from "../../api"
import { RightDrawer,  } from "../../Component/MuiEx"
import { apiResult, getUserSession, minuteToTime } from "../../Utils/Common"
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import ClassMemberList from "./fragement/ClassMemberList"
import EditClass from "./fragement/EditClass"
import { WeekDays } from "../../Utils/Dict"
import { getItemsFromObjects,  loadCourseCategories, settingDataLoader } from "../../Component/DataLoader"
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import {  Edit, PersonAdd } from "@mui/icons-material"
import { CoachLoader } from "../fragement/CoachSelector"
import EditClassMember from "./fragement/EditClassMember"

const ClassHome = (props) => {
    const params = useParams()
    const [error, setError] = useState()
    const [classobj, setClassObj] = useState()   
    const [detail,setDetail] = useState(false) 
    const [classrooms, setClassRoom] = useState()
    const [categories,setCategories] = useState()    
    const [coaches,setCoaches] = useState()
    const [memberRealod,setMemberReload] = useState(Date.now())
    const [rightDrawer, setRightDrawer] = useState()
    const [autoCloseRightDraw, setAutoCloseRightDraw] = useState(true)

    getUserSession(apis)
    const loadData = () => {
        apis.classGet(params.id, 1).then(ret => {
            apiResult(ret, data => {
                setClassObj(data)
            }, setError)
        })
    }
    let loading = false;
    useEffect(() => {
        if (!loading) {
            loading = true
            loadData()
            settingDataLoader('classroom',1,apis, (r) => { setClassRoom(r) }, setError)
            loadCourseCategories(apis,(r)=>setCategories(r),setError,1)            
            CoachLoader((data)=>setCoaches(data),apis,false,setError)
        }
    }, [])
    const handleMembersChange = (obj) => {
        setClassObj({ ...obj })
    }
    const handleLoaded = (data) => {
        // setSettledFee(data.settledFee)
        // setDividedFee(data.dividedFee)
    }
    const handleAfterEdit = (data, err, errs) => {
        apis.classPut(data).then(ret => {
            apiResult(ret, (retdata) => {
                setAutoCloseRightDraw(true)
                setRightDrawer(false)
                loadData()
            }, err, errs)
        })
    }
    const handleRightDrawer = () => {
        if (autoCloseRightDraw)
            setRightDrawer(false)
    }
    const handleEditStudent = (idx, item) => {
        setAutoCloseRightDraw(false)
        setRightDrawer(<EditClassMember classobj={classobj} data={item} onSubmit={(data, err, errs) => { handleAfterEditClassMember(idx, data, err, errs) }} onClose={() => { setRightDrawer(false) }} />)
    }
    const handleEditClass = () => {
        setAutoCloseRightDraw(false)
        setRightDrawer(<EditClass data={classobj} onSubmit={(data, err, errs) => { handleAfterEdit(data, err, errs) }} onClose={() => { setRightDrawer(false) }} />)
    }
    const handleAddStudent = () => {
        setAutoCloseRightDraw(false)
        setRightDrawer(<EditClassMember classobj={classobj} data={{ id: 0, class_id: params.id }} onSubmit={(data, err, errs) => { handleAfterEditClassMember(-1, data, err, errs) }} onClose={() => { setRightDrawer(false) }} />)
    }
    const handleAfterEditClassMember = (idx, data, err, errs) => {
        idx == -1 ? apis.classmemberPost(data).then(ret => {
            apiResult(ret, (id) => {
                setAutoCloseRightDraw(true)
                setRightDrawer(false)
                setClassObj({...classobj,students:classobj?.students+1})
                setMemberReload(Date.now())
            }, err, errs)
        }) : apis.classmemberPut(data).then(ret => {
            apiResult(ret, (retdata) => {
                setAutoCloseRightDraw(true)
                setRightDrawer(false)
                setMemberReload(Date.now())
            }, err, errs)
        })
    }
    return <Box>
        {error && <Alert severity={"error"} onClose={() => setError()}>{error}</Alert>}
        <Grid container spacing={2}>
            {classobj && <Grid item xs={12} md={6}>
                <Paper >
                    <Toolbar>
                        <Typography variant="h6" component='h6'>{classobj.name} </Typography>
                        {!detail && <Stack direction={"column"} sx={{ml:2}}>                            
                            {classobj.category_id>0?<Typography variant="body2" component={"p"}>{getItemsFromObjects(categories,classobj.category_id)?.name}</Typography>:<Typography variant="body" component={"p"}>Free class</Typography>}
                            <Typography variant="body2" >{WeekDays[classobj.week_date]} / {minuteToTime(classobj.begin_time)} - {minuteToTime(classobj.end_time)}</Typography>
                        </Stack>}
                        <Typography sx={{ flex: '1 1 10%' }} variant="h6" component="div" ></Typography>
                        <IconButton onClick={handleAddStudent} title="Add Member"><PersonAdd /></IconButton>
                        <IconButton onClick={handleEditClass}><Edit /></IconButton>                        
                        <IconButton onClick={()=>{setDetail(!detail)}} title="Detail">{!detail?<FormatAlignRightIcon/>:<KeyboardDoubleArrowUpIcon />}</IconButton>
                    </Toolbar>                                        
                    {detail && <Box sx={{p:2}}>
                    <Grid container sx={{mb:2}}>
                        <Grid item xs={4}><Typography variant="body" component={"p"}>Course:</Typography></Grid>
                        <Grid item xs={8}>
                            {classobj.category_id>0?<Typography variant="body" component={"p"}>{getItemsFromObjects(categories,classobj.category_id)?.name}</Typography>:<Typography variant="body" component={"p"}>Free class</Typography>}
                        </Grid>                        
                    </Grid>
                    {classobj.teacher_id>0 && <Grid container>
                        <Grid item xs={4}><Typography variant="body" component={"p"}>Teacher:</Typography></Grid>
                        <Grid item xs={8}><Typography variant="body" component={"p"}>{getItemsFromObjects(coaches,classobj.teacher_id)?.name}</Typography></Grid>
                    </Grid>}
                    {classobj.assistant_id>0 && <Grid container>
                        <Grid item xs={4}><Typography variant="body" component={"p"}>Assistant:</Typography></Grid>
                        <Grid item xs={8}><Typography variant="body" component={"p"}>{getItemsFromObjects(coaches,classobj.assistant_id)?.name}</Typography></Grid>
                    </Grid>}                    
                    <Grid container sx={{mb:2}}>
                        <Grid item xs={4}><Typography variant="body" component={"p"}>Students: </Typography></Grid>
                        <Grid item xs={8}><Typography variant="body" component={"p"}>{classobj.students}</Typography></Grid>
                    </Grid>                    
                    <Grid container>
                        <Grid item xs={4}><Typography variant="body" component={"p"}>Schedule:</Typography></Grid>
                        <Grid item xs={8}><Typography variant="body" component={"p"}>{WeekDays[classobj.week_date]} / {minuteToTime(classobj.begin_time)} - {minuteToTime(classobj.end_time)}</Typography></Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={4}><Typography variant="body" component={"p"}>Classroom:</Typography></Grid>
                        <Grid item xs={8}><Typography variant="body" component={"p"}>{getItemsFromObjects(classrooms,classobj.room_id)?.name}</Typography></Grid>
                    </Grid>
                    </Box>}
                </Paper>
                {/* <Paper sx={{ p: 2, mt: 2 }}>
                    <Title>Fee</Title>
                    <Typography variant="body" component={"p"}>Settled Fee: ${settledFee?.toFixed(2)}</Typography>
                    <Typography variant="body" component={"p"}>Final Income: ${dividedFee?.toFixed(2)}</Typography>
                </Paper> */}
                <Paper sx={{ p: 0, mt: 2 }}>
                    {classobj && <ClassMemberList refresh={memberRealod} all={true} onEditClassMember={handleEditStudent} onChange={handleMembersChange} classobj={classobj} classid={params.id} />}    
                </Paper>
            </Grid>
            }
            <Grid item xs={6}>
                
            </Grid>
        </Grid>
        <RightDrawer toggleDrawer={handleRightDrawer} open={rightDrawer ? true : false}>
            {rightDrawer}
        </RightDrawer>
    </Box>
}

export default ClassHome